export default __webpack_public_path__ + "assets/login_image.4fb01982.png";